import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchRelatedEntityTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'related_entity_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function saveRelatedEntityType(app, dataToSave) {
  const { user={}, data } = dataToSave;

  let relatedEntityTypeData = {
    doc_type: DocType.RELATED_ENTITY_TYPE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    default_price_level_id: data.default_price_level_id,
    system_defined: util.toBoolean(data.system_defined)
  };

  return common.saveDoc(app, {
    source: data,
    doc: relatedEntityTypeData,
    user,
  });

}

export function deleteRelatedEntityType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.RELATED_ENTITY_TYPE
  });
}

export function fetchRelatedEntityTypeById(app, params) {
  const { id } = params;
  const docType = DocType.RELATED_ENTITY_TYPE;
  return common.getDoc(app, { id, docType });
}
